import { FC } from 'react';
import { HStack, Text, Progress } from '@chakra-ui/react';

export const CustomProgress: FC<{
  value: number;
  isFileUploading?: boolean;
}> = ({ value, isFileUploading }) => {
  let color = 'yellow';
  if (value > 80) {
    color = 'green';
  } else if (value < 40) {
    color = 'red';
  } else {
    color = 'yellow';
  }

  if (isFileUploading) {
    color = 'orange';
  }

  return (
    <HStack w="full">
      <Progress
        max={100}
        value={value}
        size="sm"
        borderRadius="md"
        colorScheme={color}
        flexGrow="1"
      />
      <Text fontWeight="medium" fontSize="sm" color="custom_blue.1">
        {value} %
      </Text>
    </HStack>
  );
};
